import { OFFER_REACTIVATE_FOR_BENEFITS, TimelineData } from '../types';
import { useFetchedBillingCustomer } from './useFetchedBillingCustomer';
import { useFetchedBillingInvoices } from './useFetchedBillingInvoices';
import { getBillingPlan } from '../billingPlans';
import { generateInvoicesAndBenefits } from '../utils';
import React, { ReactElement } from 'react';

export const useTimelineData = ():
  | {
      type: 'data';
      data: TimelineData;
    }
  | {
      type: 'component';
      statusComponent: ReactElement;
    } => {
  const {
    queryStatusComponent: customerStatusComponent,
    query: { data: customer, isLoading: isCustomerLoading, isError: isCustomerError },
  } = useFetchedBillingCustomer({ withTracking: false, refetchOnWindowFocus: 'always' });

  const {
    queryStatusComponent: invoiceListStatusComponent,
    query: { data: invoices, isLoading: isInvoiceListLoading, isError: isInvoiceListError },
  } = useFetchedBillingInvoices({ withTracking: false, refetchOnWindowFocus: 'always' });

  if (isCustomerError) return { type: 'component', statusComponent: customerStatusComponent };
  if (isInvoiceListError) return { type: 'component', statusComponent: invoiceListStatusComponent };
  if (isCustomerLoading || !customer)
    return { type: 'component', statusComponent: customerStatusComponent };
  if (isInvoiceListLoading || !invoices)
    return { type: 'component', statusComponent: invoiceListStatusComponent };

  const billingPlan = getBillingPlan(customer.planName);
  if (!billingPlan) {
    return {
      type: 'component',
      statusComponent: <div>Billing plan benefits are coming soon...</div>,
    };
  }
  const toBeReactivated = customer.availableOffers.includes(OFFER_REACTIVATE_FOR_BENEFITS);
  const wasReactivated = customer.activeOffers.includes(OFFER_REACTIVATE_FOR_BENEFITS);

  const { invoicesAndBenefits, historicInvoices } = generateInvoicesAndBenefits(
    billingPlan,
    invoices,
    new Date(),
    toBeReactivated || wasReactivated
  );
  return { type: 'data', data: { invoicesAndBenefits, historicInvoices, billingPlan } };
};
